import React, { type FC } from "react";

import { Card } from "src/components";
import {
  PROFILE_BILLING_PAGE,
  PROFILE_CONFIDENTIALITY_PAGE,
  PROFILE_CREDENTIALS_PAGE,
  PROFILE_INFOS_PAGE,
  PROFILE_LANDLORD_BANKINFOS_PAGE,
  PROFILE_PAYMENTS_PAGE,
  PROFILE_PREFERENCES_PAGE,
} from "src/constants";
import { type LinkSuffix } from "src/containers/ProfileLayout/types";
import { useDeviceWidth } from "src/hooks";

type Props = {
  activeSection: LinkSuffix;
};

const SectionTitle: Record<LinkSuffix, string> = {
  [PROFILE_CREDENTIALS_PAGE]: "Identifiants de connexion",
  [PROFILE_INFOS_PAGE]: "Mes informations personnelles",
  [PROFILE_BILLING_PAGE]: "Informations de facturation",
  [PROFILE_LANDLORD_BANKINFOS_PAGE]: "Mes informations bancaires",
  [PROFILE_PAYMENTS_PAGE]: "Mon mode de paiement",
  [PROFILE_CONFIDENTIALITY_PAGE]: "Confidentialité des données",
  [PROFILE_PREFERENCES_PAGE]: "Mes services",
};

const SectionTitleCard: FC<Props> = ({ activeSection }) => {
  const { isMobile } = useDeviceWidth();

  return (
    <Card isTitle px={isMobile ? 2 : 0} textAlign={isMobile ? "center" : "unset"}>
      {SectionTitle[activeSection]}
    </Card>
  );
};

export default SectionTitleCard;
